import clicker from "@standard-library/galvo-dom-clicker";
import { Kefir as K } from "kefir";
import { times, prop, map, invoker } from "ramda";

function indexClicker(i) {
  const indicator = clicker("indicator");

  indicator.click.observe(invoker(0, "stopPropagation"));

  return {
    element: indicator.element,
    click: indicator.click.map(() => i)
  };
}

function dial(count) {
  const indexClickers = times(indexClicker, count);
  const index = K.merge(map(prop("click"), indexClickers));
  const indicators = map(prop("element"), indexClickers);
  const element = document.createElement("div");

  element.className = "indicators";

  for (var i = 0; i < indicators.length; i++) {
    element.appendChild(indicators[i]);
  }

  const highlight = (className, currentIndex) => {
    return currentIndex.observe(index => {
      const active = indicators[index];

      if (active) {
        map(i => i.classList.remove(className), indicators);
        active.classList.add(className);
      }
    });
  };

  return { element, index, highlight };
}

export default dial;



// WEBPACK FOOTER //
// ./app/javascript/packs/modules/galvo/dial.js